"use client";

import React, { useEffect, useMemo, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper-bundle.css";
import Image from "next/image";
import { CaretLeft, CaretRight } from "@phosphor-icons/react";
import { Button, Empty, Skeleton } from "antd";
import { ProductZoom } from "./product-zoom";
import { useTranslations } from "next-intl";
import axios from "axios";

const imageWh = 820;
const spaceBetween = 8;
const slidesPerView = 3;

const getImagesForProduct = (product) => {
	if (!product?.metadata) return [];
	return JSON.parse(product.media);
};

function ImageGallery({ product }) {
	const imagesList = getImagesForProduct(product) as any[];

	const [active, setActive] = useState(0);
	const [mainImage, setMainImage] = useState<any>(""); // current image
	const [videoUrl, setvideoUrl] = useState<any>(""); // current image

	const [images, setImages] = useState<any[]>([]);
	const [swiperExample, setSwiperExample] = useState<any>();
	const t = useTranslations();
	const changeProductImages = (product) => {
		if (product === null) {
			setImages([]);
			setMainImage("");
			setActive(0);
			return;
		}
	};

	useEffect(() => {
		if (product) {
			changeProductImages(product);
			setActive(0);

			getvideo();
		}
	}, [product]);

	//商品添加视屏
	async function getvideo() {
		// 获取视屏
		let coverMp4Obj = JSON.parse(product.metadata.filter((item) => item.key == "cover_mp4")[0].value)[0];
		if (coverMp4Obj) {
			let { data } = await axios(
				`${process.env.NEXT_PUBLIC_LANGUAGE_LIST_URL}/medias/video/${coverMp4Obj.id}`,
			);
			setvideoUrl(data.detail.video_url);

			if (imagesList[0] && imagesList[0].url) {
				setMainImage("");
				setImages(imagesList);
			}
		} else {
			if (imagesList[0] && imagesList[0].url) {
				setMainImage(imagesList[0].url);
				setImages(imagesList);
			}
		}
	}

	const handlePrevOrNext = (type: "prev" | "next") => {
		if (type === "prev") {
			setActive((value) => {
				if (value === 0) return value;
				setMainImage(images[value - 1].url);
				swiperExample?.slidePrev();
				return value - 1;
			});
		} else {
			setActive((value) => {
				if (value + 1 > images.length - 1) return value;
				setMainImage(images[value + 1].url);
				if (value + 1 > slidesPerView - 1) {
					swiperExample?.slideNext();
				}
				return value + 1;
			});
		}
	};

	const setActiveImgIndex = (index: number) => {
		setActive((val) => {
			if (images.length > slidesPerView) {
				const prev = document.querySelector(".button-prev") as HTMLElement;
				const next = document.querySelector(".button-next") as HTMLElement;
				index > val ? next?.click() : prev?.click();
			}
			return index;
		});
	};

	const threeModel = useMemo<any>(() => {
		const json = product.metadata.find((item) => item.key === "threeModel");
		return json ? JSON.parse(json.value)[0] : null;
	}, [product]);

	const [threeDisplay, setThreeDisplay] = useState(true);
	const handleDisplay = () => {
		setThreeDisplay(!threeDisplay);
	};

	return (
		<div className="flex !w-full select-none flex-col items-center">
			<div className="relative flex w-full items-center justify-center rounded-xl  ">
				{mainImage && images.length > 1 && (
					<div
						onClick={() => {
							handlePrevOrNext("prev");
						}}
						className="absolute left-2 z-[999]  mr-3 flex h-[35px] w-[35px] cursor-pointer items-center justify-center rounded-full
						 bg-black text-white  transition-all duration-300  hover:border-none hover:bg-white
						  hover:text-black max-md:absolute max-md:left-1 max-md:hidden"
					>
						<i className="ri-arrow-left-s-line text-[22px]"></i>
					</div>
				)}

				<div
					style={{
						maxWidth: `${imageWh}px`,
						maxHeight: `${imageWh}px`,
					}}
					className={`z-10 h-fit w-fit transition duration-300 ease-in-out ${
						!threeDisplay ? "invisible opacity-0" : "visible opacity-100"
					}`}
				>
					{(mainImage && (
						<div className="group h-full border-[1px] border-[#ddd]">
							<ProductZoom
								src={mainImage}
								imageWidth={imageWh}
								imageHeight={imageWh}
								setActiveImgIndex={setActiveImgIndex}
								quality={100}
								imgList={images}
								fit="contain"
							/>
						</div>
					)) || (
						<video
							src={videoUrl}
							poster="/image/default-image.webp"
							autoPlay
							loop
							muted
							playsInline
							className="h-[450px] w-[450px] object-cover max-lg:h-[310px] max-lg:w-[310px] "
						></video>
					)}
				</div>

				{mainImage && images.length > 1 && (
					<div
						onClick={() => {
							handlePrevOrNext("next");
						}}
						className="absolute right-2 z-[999] ml-3  mt-[15px] flex h-[35px]
						 w-[35px] cursor-pointer items-center justify-center rounded-full bg-black text-white
						  transition-all duration-300 hover:bg-white hover:text-black  max-md:left-1 max-md:hidden"
					>
						<i className="ri-arrow-right-s-line text-[20px]"></i>
					</div>
				)}
			</div>

			<div
				style={{
					maxWidth: `${imageWh}px`,
					height: `${imageWh / 5}px`,
				}}
				className="relative mt-2 flex w-full items-center justify-between md:mt-[70px]"
			>
				<>
					{/* {images.length > slidesPerView && (
						<>
							<div
								onClick={() => {
									handlePrevOrNext("prev");
								}}
								className={`button-prev ri-arrow-left-s-line ri-3x absolute left-[-50px] z-[2] cursor-pointer text-black max-lg:left-0 lg:z-[1]`}
							/>
							<div
								onClick={() => {
									handlePrevOrNext("next");
								}}
								className={`button-next ri-arrow-right-s-line ri-3x absolute right-[-50px] z-[2] cursor-pointer  text-black max-lg:right-0 lg:z-[1]`}
							/>
						</>
					)} */}

					<Swiper
						onSwiper={setSwiperExample}
						className="w-full"
						spaceBetween={spaceBetween}
						slidesPerView={slidesPerView}
						navigation={{
							nextEl: ".button-next",
							prevEl: ".button-prev",
						}}
					>
						{images &&
							images?.map((image: any, index: number) => (
								<SwiperSlide key={index}>
									<div
										className={`flex h-fit w-fit cursor-pointer items-center justify-center overflow-hidden  border-[1px] duration-300 ${
											active === index ? " border-black" : "border-themeSecondary200"
										}`}
										onMouseEnter={() => {
											setMainImage(image.url);
											setActive(index);
										}}
									>
										<div className="relative hidden aspect-square object-cover sm:flex sm:items-center sm:justify-center">
											<Image quality={100} src={image.url} width={275} height={300} alt={"product image "} />
										</div>
										<div className="relative flex aspect-square sm:hidden">
											<Image quality={100} src={image.url} width={275} height={300} alt={"product image "} />
										</div>
									</div>
								</SwiperSlide>
							))}
					</Swiper>
				</>
			</div>
		</div>
	);
}

export default React.memo(ImageGallery);
